import { Box, Button, Divider, Flex } from "@chakra-ui/react";
import { CalendarContainer } from "react-datepicker";
import { ShortCut } from "./enum";
import { calenderStyle } from "./styles";
import moment from "moment";
import { getShortCutName } from "../../helpers/string";
import { CalendarContainerProps } from "react-datepicker/dist/calendar_container";

const PopperContainer = ({
  className,
  children,
  selectedDates,
  onCancel,
  onConfirm,
  onOptionClick,
}: CalendarContainerProps & {
  selectedDates?: [Date | null, Date | null];
  onCancel: () => void;
  onConfirm: () => void;
  onOptionClick: (option: ShortCut) => void;
}) => {
  const isDisabled = !selectedDates || !selectedDates[0] || !selectedDates[1];

  const shortCuts: ShortCut[][] = [
    [
      ShortCut.TODAY,
      ShortCut.YESTERDAY,
      ShortCut.THIS_WEEK,
      ShortCut.THIS_MONTH,
      ShortCut.THIS_YEAR,
    ],
  ];

  return (
    <Box
      boxShadow="rgba(0, 0, 0, 0.12) 0px 4px 8px"
      borderRadius="8px"
      bgColor="white"
      sx={calenderStyle}
      p={2}
    >
      <Flex>
        <Flex
          flexDirection="column"
          w="160px"
          maxH="280px"
          overflow="auto"
          pr={4}
        >
          {shortCuts.map((elm, index) => {
            return (
              <Box key={`${index}`}>
                {elm.map((elm2, index2) => {
                  return (
                    <Button
                      variant="link"
                      size="xs"
                      px={2}
                      py={2}
                      key={`${index}-${index2}`}
                      textAlign="left"
                      justifyContent="flex-start"
                      onClick={() => onOptionClick(elm2)}
                      _hover={{
                        bgColor: "#e3f4ff",
                        color: "#4199d5",
                      }}
                      w="100%"
                    >
                      {getShortCutName(elm2)}
                    </Button>
                  );
                })}
                {index < shortCuts.length - 1 && <Divider />}
              </Box>
            );
          })}
        </Flex>

        <CalendarContainer className={className}>
          <div style={{ position: "relative" }}>{children}</div>
        </CalendarContainer>
      </Flex>
      <Divider my={2} />
      <Flex px={2} py={2} justifyContent="space-between" alignItems="center">
        <Box
          fontSize="14px"
          fontWeight={600}
          color={isDisabled ? "textDisabled" : "inherit"}
        >
          {selectedDates && selectedDates[0] && selectedDates[1] ? (
            `${moment(selectedDates[0]).format("D MMMM Y")} - ${moment(
              selectedDates[1]
            ).format("D MMMM Y")}`
          ) : selectedDates && selectedDates[0] ? (
            moment(selectedDates[0]).format("D MMMM Y")
          ) : (
            <></>
          )}
        </Box>
        <Flex gap={4}>
          <Button size="sm" variant="link" onClick={onCancel}>
            Cancel
          </Button>
          <Button size="sm" onClick={onConfirm} isDisabled={isDisabled}>
            Select
          </Button>
        </Flex>
      </Flex>
    </Box>
  );
};

export default PopperContainer;
